import React, { useRef } from 'react'
import IconArrowLeft from 'svg/icons/arrow-left.svg'
import IconArrowRight from 'svg/icons/arrow-right.svg'
import Slider from 'react-slick'

import './slider.scss'

const SmallSlider = ({ autoplay, infinite, showPerSlide, theme, items }) => {
	const sliderRef = useRef(null)

	const SlickArrowsFix = ({ children, ...props }) => (
		<button className="smallSlider_control" {...props}>
			{children}
		</button>
	)
	const settings = {
		draggable: false,
		swipeToSlide: false,
		swipe: false,
		autoplay: autoplay,
		infinite: infinite,
		speed: 500,
		lazyLoad: 'ondemand',
		nextArrow: (
			<SlickArrowsFix>
				<IconArrowRight />
			</SlickArrowsFix>
		),
		prevArrow: (
			<SlickArrowsFix>
				<IconArrowLeft />
			</SlickArrowsFix>
		),
		slidesToShow: showPerSlide,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	}

	return (
		<div className={`smallSlider smallSlider-${theme}`}>
			<Slider ref={sliderRef} {...settings}>
				{items.map((item) => (
					<div className="smallSlider_item" key={item.id}>
						{item.content}
					</div>
				))}
			</Slider>
		</div>
	)
}

export default SmallSlider
